import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const InventoryReports = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Envanter Raporları
      </Typography>
      <Paper sx={{ p: 2 }}>
        <Typography>Envanter raporları burada görüntülenecek</Typography>
      </Paper>
    </Box>
  );
};

export default InventoryReports;
